import { createAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  getClientListData,
  getClientListNearestData,
} from '../../services/clients.service';

export const fetchClientListData = createAsyncThunk(
  'clientListData/fetch',
  async () => {
    return getClientListData();
  }
);

export const fetchClientListNearestData = createAsyncThunk(
  'clientListNearestData/fetch',
  async ({ coords, page }) => {
    const { latitude, longitude } = coords;
    return getClientListNearestData(latitude, longitude, page);
  }
);

export const fetchMoreClientListNearestData = createAsyncThunk(
  'clientListMoreNearestData/fetch',
  async ({ coords, page }) => {
    const { latitude, longitude } = coords;
    return getClientListNearestData(latitude, longitude, page);
  }
);

/* prettier-ignore */
export const postClient = createAction(
  'client/post',
  function prepare(clientId, clientData) {
    return {
      payload: {
        clientId,
        clientData,
      },
      meta: {
        offline: {
          effect: {
            url: `/qac/client/${clientId}`,
            method: 'POST',
            data: clientData,
          },
          commit: {
            type: 'client/post/commit',
            meta: {
              clientId,
              clientData,
            },
          },
          rollback: { type: 'client/post/rollback', meta: { clientId } },
        },
      },
    };
  }
);

/* prettier-ignore */
export const putClient = createAction(
  'client/put',
  function prepare(clientId, clientData) {
    return {
      payload: {
        clientId,
        clientData,
      },
      meta: {
        offline: {
          effect: {
            url: `/qac/client/${clientId}`,
            method: 'PUT',
            data: clientData,
          },
          commit: {
            type: 'client/put/commit',
            meta: {
              clientId,
              clientData,
            },
          },
          rollback: { type: 'client/put/rollback', meta: { clientId } },
        },
      },
    };
  }
);

/* prettier-ignore */
export const setSearchedClients = createAction(
  'client/search',
  function prepare(searchedClients) {
    return {
      payload: {
        searchedClients,
      },
    };
  }
);

export const addClientToSearch = createAction(
  'client/addClientToSearch',
  function prepare(clientListItemData) {
    return {
      payload: {
        clientListItemData,
      },
    };
  }
);

export const addClientToPlannedClients = createAction(
  'client/addClientToPlannedClients',
  function prepare(clientId, clientAction) {
    return {
      payload: {
        clientId,
        clientAction,
      },
    };
  }
);

export const deleteClientFromPlannedClients = createAction(
  'client/deleteClientFromPlannedClients',
  function prepare(clientId) {
    return {
      payload: {
        clientId,
      },
    };
  }
);

const clientsSlice = createSlice({
  name: 'customers',
  initialState: {
    clients: [],
    clientsFetched: false,
    loadingClients: false,
    nearestClients: [],
    nearestClientsFetched: false,
    totalNearestClients: null,
    loadingNearestClients: false,
    searchedClients: [],
  },
  reducers: {},
  extraReducers: {
    [fetchClientListData.pending]: (state) => {
      state.loadingClients = true;
    },
    [fetchClientListData.fulfilled]: (state, action) => {
      state.loadingClients = false;
      state.clientsFetched = true;
      state.clients = action.payload?.data.sort((a, b) =>
        a.visitAddress.name.localeCompare(b.visitAddress.name)
      );
    },
    [fetchClientListData.rejected]: (state) => {
      state.loadingClients = false;
      state.clientsFetched = true;
    },
    [fetchClientListNearestData.pending]: (state) => {
      state.loadingNearestClients = true;
    },
    [fetchClientListNearestData.fulfilled]: (state, action) => {
      state.loadingNearestClients = false;
      state.nearestClientsFetched = true;
      state.nearestClients = action.payload.data;
      state.totalNearestClients = action.payload.total;
    },
    [fetchClientListNearestData.rejected]: (state) => {
      state.loadingNearestClients = false;
      state.nearestClientsFetched = true;
    },
    [fetchMoreClientListNearestData.fulfilled]: (state, action) => {
      state.nearestClients = [...state.nearestClients, ...action.payload.data];
      state.loadingNearestClients = false;
    },
    [setSearchedClients]: (state, action) => {
      state.searchedClients = action.payload.searchedClients;
    },
    [addClientToSearch]: (state, action) => {
      const { clientListItemData } = action.payload;
      state.clients.push({ ...clientListItemData });
    },
  },
});

export default clientsSlice.reducer;
